import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { fmtDate } from "@/lib/format";

const pad = (n) => String(n).padStart(2, "0");
const toYmd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const fromYmd = (s) => { if (!s) return undefined; const [y, m, d] = s.split("-").map(Number); return new Date(y, m - 1, d); };

const mask = (raw) => {
  const d = raw.replace(/\D/g, "").slice(0, 8);
  return [d.slice(0, 2), d.slice(2, 4), d.slice(4)].filter(Boolean).join("/");
};

const parse = (txt) => {
  const m = txt.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return null;
  const dt = new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]));
  return dt.getDate() === Number(m[1]) && dt.getMonth() === Number(m[2]) - 1 ? toYmd(dt) : null;
};

export default function DateInput({ value, onChange, max, className = "", testid, ...rest }) {
  const [text, setText] = useState(value ? fmtDate(value) : "");
  const [open, setOpen] = useState(false);
  useEffect(() => { setText(value ? fmtDate(value) : ""); }, [value]);

  const type = (e) => {
    const t = mask(e.target.value);
    setText(t);
    if (!t) onChange("");
    const ymd = parse(t);
    if (ymd) onChange(ymd);
  };

  return (
    <div className="relative">
      <Input value={text} onChange={type} onBlur={() => setText(value ? fmtDate(value) : "")} placeholder="dd/mm/yyyy" inputMode="numeric"
        autoComplete="off" className={`pr-9 num ${className}`} data-testid={testid} {...rest} />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" tabIndex={-1} className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-emerald-700" data-testid={testid ? `${testid}-calendar` : undefined}>
            <CalendarDays className="w-4 h-4" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-white" align="end">
          <Calendar mode="single" selected={fromYmd(value)} defaultMonth={fromYmd(value)} toDate={fromYmd(max)}
            onSelect={(d) => { if (d) { onChange(toYmd(d)); setOpen(false); } }} />
        </PopoverContent>
      </Popover>
    </div>
  );
}
